/**
 * @Author: Matthias Gohla <Matze>
 * @Date:   2016-09-22T11:32:28+02:00
 * @Email:  matze_lebt@gmx.de
 * @Last modified by:   mBook
 * @Last modified time: 2016-10-07T13:56:27+02:00
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AIconInline from 'common/icons/components/AIconInline';
import {
  createNumberFormatter,
} from 'common/inputs/masks/numberMask';
import applyRatesToComponent from 'checkout/utils/paymentConditions';
import {i18nInterface} from 'utilities/i18n_common';

const formatCurrency = createNumberFormatter({
  prefix: '',
  suffix: ' €',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: false,
  decimalSymbol: ',',
  decimalLimit: 2,
  requireDecimal: false,
  allowNegative: false,
});

const formatCurrencyPrecise = createNumberFormatter({
  prefix: '',
  suffix: ' €',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  requireDecimal: true,
  allowNegative: false,
});

const ICON_NAME = 'shopping-cart';

/**
 * MTopbarCheckout - …
 **/
class MTopbarCheckout extends Component {
  /**
   * TODO jsdoc
   *
   * @param {object} props
   * @return {undefined}
   */
  constructor(props) {
    super(props);
    this.state = {
      ratePerPayment: '…',
      feeText: i18nInterface('label.feeText1') +
        i18nInterface('label.annualPayment') +
        i18nInterface('label.feeText2'),
    };
  }

  /**
   * TODO jsdoc
   *
   * @param {object} nextProps
   * @return {undefined}
   */
  componentWillReceiveProps(nextProps) {
    const {
      deposit,
      paymentConditions,
    } = this.props;

    if (
      deposit != nextProps.deposit ||
      paymentConditions != nextProps.paymentConditions
    ) {
      applyRatesToComponent(
          this,
          nextProps.deposit,
          nextProps.paymentConditions,
          formatCurrencyPrecise,
      );
    }
  }

  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  componentDidMount() {
    const {
      deposit,
      paymentConditions,
    } = this.props;
    applyRatesToComponent(
        this, deposit, paymentConditions, formatCurrencyPrecise,
    );
  }

  /**
   * TODO jsdoc
   *
   * @return {object}
   */
  render() {
    const {
      deposit,
      icon,
      showLogoInsteadOfFee,
    } = this.props;

    const formattedDeposit = formatCurrency(deposit);
    const depositText = i18nInterface('label.banner1') + formattedDeposit +
      i18nInterface('label.banner2');

    return (
      <div className="m-topbar m-topbar-checkout">
        <div className="m-topbar-checkout__wrapper">
          <div className="m-topbar-checkout__wrapper-content">
            <AIconInline
              icon={icon}
              size="normal"
            />
            <p className="m-topbar-checkout__fee-text">
              {depositText}
            </p>
            <p className="m-topbar-checkout__fee-text">
              {this.state.feeText}
            </p>
            <p className="m-topbar-checkout__fee">
              {this.state.ratePerPayment}
            </p>
          </div>
        </div>
      </div>
    );
  }
}


MTopbarCheckout.propTypes = {
  deposit: PropTypes.number,
  /**
   * function which calculates the fee based on the deposit value
   */
  icon: PropTypes.string,
  /**
   * shows a blank header with just a logo instead of the fee
   */
  showLogoInsteadOfFee: PropTypes.bool.isRequired,
  /**
   * payment conditions to be sent to ajax webservice for calculation
   */
  paymentConditions: PropTypes.string,
};
MTopbarCheckout.defaultProps = {
  deposit: 0,
  icon: ICON_NAME,
  showLogoInsteadOfFee: false,
  paymentConditions: '1',
};
export default MTopbarCheckout;

